export default __webpack_public_path__ + "static/media/right_bottom_image_tablet.aa60a805.png";